// extracted by mini-css-extract-plugin
export default {"marginBottom":"accountDetails_marginBottom__3wfO3","margin":"accountDetails_margin__oke0z"};